import { NavItemModel } from '../../common';

export const CATALOG_SEARCH_ROUTE_NAME: string = 'search';
export const CATALOG_SEARCH_ROUTE_PATH: string = 'search';
export const catalogSearchNavItem: NavItemModel = {
  name: CATALOG_SEARCH_ROUTE_NAME,
  url: `/${CATALOG_SEARCH_ROUTE_PATH}`,
  label: 'Suche',
};

export const CATALOG_PRODUCT_ROUTE_NAME: string = 'product';
export const CATALOG_PRODUCT_ROUTE_PATH: string = 'product/:sku';
export const catalogProductNavItem: NavItemModel = {
  name: CATALOG_PRODUCT_ROUTE_NAME,
  url: `/${CATALOG_PRODUCT_ROUTE_PATH}`,
  label: 'Produkt',
};

export const CATALOG_CONFIGURABLE_BUNDLE_NAME: string = 'configurable-bundle';
export const CATALOG_CONFIGURABLE_BUNDLE_ROUTE_PATH: string = 'configurable-bundles/:templateId';
export const catalogConfigurableBundleNavItem: NavItemModel = {
  name: CATALOG_CONFIGURABLE_BUNDLE_NAME,
  url: `/${CATALOG_CONFIGURABLE_BUNDLE_ROUTE_PATH}`,
  label: 'Konfigurierbares Bundle',
};

export const catalogNavigationItems: NavItemModel[] = [
  catalogSearchNavItem,
  catalogProductNavItem,
  catalogConfigurableBundleNavItem,
];
